import { defineMessages } from 'react-intl';

type MessageKeys = 'expandIconLabel' | 'collapseIconLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		expandIconLabel: {
			id: 'ai-mate.chat-history.loading-state.expand-icon',
			defaultMessage: 'Expand',
			description:
				'Accessibility label (aria-label) for a chevron-right icon button in an expandable loading step within the AI conversation interface that expands to show more details about the loading process. Shown as a screen reader announcement when the icon is focused or hovered. When clicked, it expands the loading step to reveal additional information. The purpose is to provide accessible information about the expand action for users with assistive technologies.',
		},
		collapseIconLabel: {
			id: 'ai-mate.chat-history.loading-state.collapse-icon',
			defaultMessage: 'Collapse',
			description:
				'Accessibility label (aria-label) for a chevron-down icon button in an expanded loading step within the AI conversation interface that collapses to hide details about the loading process. Shown as a screen reader announcement when the icon is focused or hovered. When clicked, it collapses the loading step to show only a summary. The purpose is to provide accessible information about the collapse action for users with assistive technologies.',
		},
	});

export default message;
